module.exports = __webpack_public_path__ + "img/gold-line.52a44fc5.svg";